// src/routes/DeviceRoute.tsx
import * as React from 'react';
import useMediaQuery from '@mui/material/useMediaQuery';

type Props = {
  desktop: React.ComponentType<any>;
  mobile?: React.ComponentType<any>;
  props?: Record<string, any>;
  /** 모바일 판정 브레이크포인트(px). 기본 900 */
  mobileMaxWidth?: number;
  /** 강제로 모바일 렌더 (테스트/디버깅용) */
  forceMobile?: boolean;
  /** 강제로 데스크톱 렌더 (테스트/디버깅용) */
  forceDesktop?: boolean;
};

/**
 * 기기별 컴포넌트 선택 유틸.
 *
 * SEO 원칙:
 * - URL은 데스크톱/모바일에서 동일하게 유지한다.
 * - /m/* 같은 별도 URL을 만들지 않는다.
 * - 화면 크기에 따라 렌더할 컴포넌트만 바꾼다.
 */
const DeviceRoute: React.FC<Props> = ({
  desktop: Desktop,
  mobile: Mobile,
  props,
  mobileMaxWidth = 900,
  forceMobile,
  forceDesktop,
}) => {
  const query = React.useMemo(
    () => `(max-width:${mobileMaxWidth - 0.02}px)`,
    [mobileMaxWidth],
  );

  const mqIsMobile = useMediaQuery(query, { noSsr: true });

  const effectiveIsMobile = React.useMemo(() => {
    if (forceDesktop) return false;
    if (forceMobile) return true;
    return mqIsMobile;
  }, [forceDesktop, forceMobile, mqIsMobile]);

  const Comp = effectiveIsMobile && Mobile ? Mobile : Desktop;
  return <Comp {...(props || {})} />;
};

export default DeviceRoute;
